<script setup>
const props = defineProps({
    color: {
        type: String,
        default: "black",
    },
});
</script>

<template>
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M4 7L7.29289 10.2929C7.68342 10.6834 8.31658 10.6834 8.70711 10.2929L12 7"
            :stroke="color"
            stroke-width="1.5"
            stroke-linecap="round"
        />
    </svg>
</template>
